<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <h1>{{detailContent.title}}</h1>
            <div class="source"><span>发布日期:</span>{{detailContent.date}}</div>
            <div class="content">
                <div class="content_detail" v-html="detailContent.content"></div>
                <div class="file" v-if="showFiles">
                    <h2>附件:</h2>
                    <ul>
                        <li v-for="item in detailContent.files" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                    </ul>
                </div>

                <!-- 我要报名 -->
                <div class="sign_up_box_m" v-show="showForm">
                    <h2>我要报名</h2>
                    <van-form ref="form" @submit="onSubmit">
                        <van-cell v-for="(item, index) in form.itemLists" :key="index">
                            <!-- text input -->
                            <van-field v-if="item.type==='text'" v-model="item.value" :label="item.name" :rules="[{ required: true, message: `请输入${item.name}` }]" />
                            <!-- 日期 -->
                            <van-field v-if="item.type==='time' || item.type==='date'" :label="item.name" v-model="item.value" @click="handleDate(item.name)" />
                            <van-popup v-model="showCalendar" position="bottom" v-if="item.type==='time' || item.type==='date'">
                                <van-datetime-picker v-model="currentDate" type="date" @confirm="onConfirm(...arguments,dateName)" @cancel="onCancel" />
                            </van-popup>
                            <!-- 日期 year -->
                            <van-field v-if="item.type==='year'" :label="item.name" v-model="item.value" @click="handleDateYear(item.name)" />
                            <van-popup v-model="showCalendarYear" position="bottom" v-if="item.type==='year'">
                                <van-datetime-picker v-model="currentDate" type="year-month" @confirm="onConfirm(...arguments,dateName)" @cancel="onCancel" />
                            </van-popup>
                            <!-- 日期 month -->
                            <van-field v-if="item.type==='month'" :label="item.name" v-model="item.value" @click="handleDateMonth(item.name)" />
                            <van-popup v-model="showCalendarMonth" position="bottom" v-if="item.type==='month'">
                                <van-datetime-picker v-model="currentDate" type="year-month" @confirm="onConfirm(...arguments,dateName)" @cancel="onCancel" />
                            </van-popup>
                            <!-- 单选框 -->
                            <van-field name="radio" :label="item.name" v-if="item.type=='radio'" class="radio_box">
                                <template #input>
                                    <van-radio-group v-model="item.value" direction="horizontal">
                                        <van-radio v-for="(itemRadio,i) in item.options" :key="i" :name="itemRadio.value">{{itemRadio.label}}</van-radio>
                                    </van-radio-group>
                                </template>
                            </van-field>
                            <!-- 复选框 -->
                            <van-field name="checkboxGroup" :label="item.name" v-if="item.type=='checkbox'" class="check_box">
                                <template #input>
                                    <van-checkbox-group v-model="item.value" direction="horizontal">
                                        <van-checkbox :name="itemCheckbox.value" shape="square" v-for="(itemCheckbox,j) in item.options" :key="j">{{itemCheckbox.label}}</van-checkbox>
                                    </van-checkbox-group>
                                </template>
                            </van-field>
                        </van-cell>

                        <van-field v-if="showPhone" v-model="form.mobile" label="手机号" maxlength="11" name="mobile"
                        :rules="[
                            { required: true, message: '请填写您的手机号码' },
                            { pattern: /^1\d{10}$/, message: '手机号码格式错误'}
                        ]" />
                        <!-- 验证码 -->
                        <van-cell v-if="showCode" class="code_box">
                                <van-field v-model="form.code" label="验证码" :rules="[{ required: true, message: `请输入验证码` }]" />
                                <div class="getCode" v-show="!showVerCode" @click="showVerCoding">获取验证码</div>
                                <van-count-down v-show="showVerCode" :time="60000" :auto-start="false" format="ss秒后重新获取" ref="countdown" @finish="finish" />
                        </van-cell>

                        <van-button type="info" class="btn_submit" native-type="submit">提交</van-button>

                    </van-form>
                </div>

            </div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { getVeteranDetail,updateTrain,getSmsCode } from '@/service/api.js'
import { dateFormat } from '@/utils/util.js'
import {encrypt} from "../../../utils/jsencrypt";

export default {
    components: { BottomMenu },
    data() {
        return {
            showCode:false,
            showPhone:false,
            showCalendar:false,
            showVerCode:false,
            showCalendarYear:false,
            showCalendarMonth:false,
            detailContent:{
                title:'',
                content:'',
                date:'',
                files:[]
            },
            showFiles:false,
            showForm:true,
            form:{
                itemLists:[],
                code:'',
                mobile:''
            },
            saveParams:[],
            currentDate:new Date(),
            dateName:''
        }
    },
    methods: {
        handleDate(name){
            this.dateName = name
            this.showCalendar = true
        },
        handleDateYear(name){
            this.dateName = name
            this.showCalendarYear = true
        },
        handleDateMonth(name){
            this.dateName = name
            this.showCalendarMonth = true
        },
        onCancel(){
            this.showCalendar = false;
            this.showCalendarYear = false
            this.showCalendarMonth = false
        },
        onConfirm(...args){
            this.showCalendar = false;
            this.showCalendarYear = false
            this.showCalendarMonth = false
            this.form.itemLists.forEach(el => {
                if (el.name === args[1]) {
                    el.value = this.formatDate(args[0])
                    this.currentDate = this.formatDate(args[0])
                }
            });
        },
        formatDate(date) {
            return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
        },
        showVerCoding(){
            this.$refs.form.validate('mobile').then(() => {
                this.showVerCode = true
                this.$refs.countdown.start()
                getSmsCode({mobile:encrypt(''+this.form.mobile)}).then(data=>{
                    if (data.code!==0) {
                        this.$toast(data.msg)
                    }else{
                        console.log(data);
                    }
                })
            }).catch(() => {
                this.$toast('请填写正确的手机号')
            })
        },
        finish(){
            this.showVerCode = false
            this.$refs.countdown.reset()
        },
        onSubmit() {
            this.$refs.form.validate().then(() => {
                this.saveParams=[];
                for (let i = 0; i < this.form.itemLists.length; i++) {
                    let temp = {};
                    temp.name = this.form.itemLists[i].name
                    temp.eName = this.form.itemLists[i].eName
                    temp.value = this.form.itemLists[i].value
                    this.saveParams.push(temp)
                }
                if (this.form.mobile) {
                    let temp = {};
                    temp.name = '手机号'
                    temp.eName = 'ShouJiHao'
                    temp.value = this.form.mobile
                    this.saveParams.push(temp)
                }
                updateTrain(this.saveParams,this.$route.params.id,this.form.code).then(data=>{
                    if (data.code !==0) {
                        this.$toast(data.msg)
                    }else{
                        this.$toast('报名成功')
                        if (data.token) {
                            localStorage.setItem('token',data.token)
                            this.$router.push({name:'PersonalTrain'})
                        }else{
                            this.$router.push({name:'Home'})
                        }
                    }
                })
            }).catch(() => {
                this.$toast('提交失败')
            })
        },
    },
    mounted () {
        getVeteranDetail('?id='+this.$route.params.id).then(data=>{
            console.log('接收到的：',data);
            JSON.stringify(data.data.signupData)==='{}' ? this.showForm = false : this.showForm = true
            // 内容展示
            this.detailContent.title = data.data.title;
            this.detailContent.date = dateFormat(data.data.createTime,'Y年M月D日');
            this.detailContent.content = data.data.content
            if (data.data.files) {
                this.detailContent.files = JSON.parse(data.data.files)
            }
            if(this.detailContent.files.length>0){
                this.showFiles = true
            }

            // 表单生成
            const nameList = Object.keys(data.data.signupData)
            console.log('nameList',Object.entries(data.data.signupData));
            for (let i = 0; i < nameList.length; i++) {
                let temp = {};
                if (nameList[i]==='手机号') {
                    this.showCode = true
                    this.showPhone = true
                }else{
                    temp.name = nameList[i]
                    temp.eName = data.data.signupData[nameList[i]][nameList[i]].value
                    if(data.data.signupData[nameList[i]][nameList[i]].typeId==='checkbox'){
                        temp.value = []
                    }else{
                        temp.value = ''
                    }
                    temp.type = data.data.signupData[nameList[i]][nameList[i]].typeId
                    temp.options = data.data.signupData[nameList[i]][nameList[i]].options
                    this.form.itemLists.push(temp)
                }
            }
            console.log(this.form);
        });
    },
}

</script>
